import {NavLink} from 'react-router-dom';

import {ReactComponent as AccountIcon} from 'src/assets/icons/image-user.svg';
import {ReactComponent as ReceiptIcon} from 'src/assets/icons/receipt.svg';
import {ReactComponent as PlansIcon} from 'src/assets/icons/file-06.svg';
import {ReactComponent as BillingIcon} from 'src/assets/icons/credit-card-02.svg';
import {ReactComponent as KeyIcon} from 'src/assets/icons/key-01.svg';
import {ReactComponent as UsersIcon} from 'src/assets/icons/users-01.svg';
import {ReactComponent as UsersCheckIcon} from 'src/assets/icons/users-check.svg';
import {ReactComponent as SecurityIcon} from 'src/assets/icons/security-svgrepo-com.svg';
import {ReactComponent as WalletIcon} from 'src/assets/icons/wallet-icon.svg';
import {useSelector} from 'react-redux';
import {RootState} from '../../store';
import {FeatureFlags} from '../../utils/features';
import CoinIcon from '../../assets/icons/coin_icon.svg';
import {useEffect, useState} from 'react';
import {nFetch} from '../../api/nFetch';

export function SettingsSidebar() {
    const [userProfile, metricsProps] = [
        useSelector((state: RootState) => state.userProfile),
        useSelector((state: RootState) => state.metrics),
    ];
    const [walletBalance, setWalletBalance] = useState(0);

    useEffect(() => {
        if (metricsProps.balance) {
            setWalletBalance(metricsProps.balance);
        }
    }, [metricsProps.balance]);

    const isFeatureEnabled = (feature: FeatureFlags) => {
        return userProfile.currentOrganization.enabled_features.indexOf(feature) > -1;
    };

    const BtnStyle = {
        active:
            'text-blue-600 font-semibold' +
            ' px-3 py-2 rounded-md mt-4' +
            ' flex flex-row items-center' +
            ' stroke-blue-600 hover:stroke-blue-800' +
            ' bg-blue-50' +
            ' hover:bg-blue-100 hover:text-blue-800',
        default:
            'text-gray-700 font-semibold' +
            ' px-3 py-2 rounded-md mt-4' +
            ' flex flex-row items-center' +
            ' stroke-gray-700 hover:stroke-gray-900' +
            ' hover:bg-gray-50 hover:text-gray-900',
    };

    return (
        <div className={'hidden w-fit min-w-fit flex-col border border-solid border-gray-200 px-4 py-4 pt-8 md:flex'}>
            {/*PROFILE*/}
            <NavLink
                to={'/settings/profile'}
                className={({isActive, isPending}) => {
                    return isActive ? BtnStyle.active : BtnStyle.default;
                }}>
                <AccountIcon className={'mr-3 h-6 w-6'} aria-label={'Account Icon'} />
                Account
            </NavLink>

            {/*PLANS*/}
            <NavLink
                to={'/settings/plans'}
                className={({isActive, isPending}) => {
                    return isActive ? BtnStyle.active : BtnStyle.default;
                }}>
                <PlansIcon className={'mr-3 h-6 w-6'} aria-label={'Billing Icon'} />
                Plans
            </NavLink>

            {/*BILLING*/}
            <NavLink
                to={'/settings/billing'}
                className={({isActive, isPending}) => {
                    return isActive ? BtnStyle.active : BtnStyle.default;
                }}>
                <ReceiptIcon className={'mr-3 h-6 w-6'} aria-label={'Billing Icon'} />
                Billing Information
            </NavLink>

            {/*INVOICES*/}
            <NavLink
                to={'/settings/invoices'}
                className={({isActive, isPending}) => {
                    return isActive ? BtnStyle.active : BtnStyle.default;
                }}>
                <BillingIcon className={'mr-3 h-6 w-6'} aria-label={'Billing Icon'} />
                Invoices
            </NavLink>

            <NavLink
                to={'/settings/wallet'}
                className={({isActive}) => {
                    return isActive ? BtnStyle.active : BtnStyle.default;
                }}>
                {({isActive}) => (
                    <>
                        <WalletIcon className={'mr-3 h-6 w-6'} aria-label={'Billing Icon'} />
                        Wallet
                        {!isActive && (
                            <div className='flex gap-1'>
                                &nbsp;
                                <img src={CoinIcon} alt='coin' />
                                <span className='font-[600]'>{walletBalance}</span>
                            </div>
                        )}
                    </>
                )}
            </NavLink>

            {/*API Keys*/}
            <NavLink
                to={'/settings/keys'}
                className={({isActive, isPending}) => {
                    return isActive ? BtnStyle.active : BtnStyle.default;
                }}>
                <KeyIcon className={'mr-3 h-6 w-6'} aria-label={'API Keys Icon'} />
                API Keys
            </NavLink>

            {/*User Management*/}
            <NavLink
                to={'/settings/users'}
                className={({isActive, isPending}) => {
                    return isActive ? BtnStyle.active : BtnStyle.default;
                }}>
                <UsersIcon className={'mr-3 h-6 w-6'} aria-label={'API Keys Icon'} />
                Users
            </NavLink>

            {/*User Invitations*/}
            <NavLink
                to={'/settings/invitations'}
                className={({isActive, isPending}) => {
                    return isActive ? BtnStyle.active : BtnStyle.default;
                }}>
                <UsersCheckIcon className={'mr-3 h-6 w-6'} aria-label={'User Invitations Icon'} />
                Invitations
            </NavLink>

            {/*Security*/}
            <NavLink
                to={'/settings/security'}
                className={({isActive, isPending}) => {
                    return isActive ? BtnStyle.active : BtnStyle.default;
                }}>
                <SecurityIcon className={'mr-3 h-6 w-6'} aria-label={'Security Icon'} />
                Security
            </NavLink>
        </div>
    );
}
